/* istanbul ignore file */

import { closestCenter, DndContext, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'

import { deliveryMethodVisibility } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/constants'

import SortableDeliveryMethod from './SortableDeliveryMethod'

const SortableDeliveryMethodList = ({
  deliveryMethods,
  regions,
  handleChangeEnabled,
  handleOnEdit,
  handleOnOpenDeleteDeliveryMethodModal,
  handleDuplicateDeliveryMethod,
  dragging,
  isEditable,
  onSortStart,
  onSortEnd,
}) => {
  const sensors = useSensors(useSensor(PointerSensor))

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onSortEnd} onDragStart={onSortStart}>
      <SortableContext items={deliveryMethods} strategy={verticalListSortingStrategy}>
        <div>
          {deliveryMethods.map((deliveryMethod, index) => (
            <SortableDeliveryMethod
              key={deliveryMethod.id}
              data={deliveryMethod}
              index={index}
              position={index}
              regions={regions}
              onEdit={handleOnEdit}
              onDelete={handleOnOpenDeleteDeliveryMethodModal}
              onDuplicate={handleDuplicateDeliveryMethod}
              onChangeEnabled={handleChangeEnabled}
              dragging={dragging}
              isEditable={isEditable}
              showVisibilityInternalChip={deliveryMethod.visibility === deliveryMethodVisibility.internal}
            />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  )
}

export default SortableDeliveryMethodList
